import { createSlice } from '@reduxjs/toolkit';
import { guessLocale, guessDateFormat, guessTimeFormat } from '../../services/helpers/preferences';

export const selectLocale = (state) => state.preferences.locale;
export const selectDateFormat = (state) => state.preferences.dateFormat;
export const selectTimeFormat = (state) => state.preferences.timeFormat;


export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: {
    locale: guessLocale(),
    dateFormat: guessDateFormat(),
    timeFormat: guessTimeFormat(),
  },
});

export default preferencesSlice.reducer;
